import DiscountContext from '~/context/common/DiscountContext';
import TradeContext from '~/context/common/TradeContext';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import { useGetCkPromoFromDiscountContext } from '~/hooks/common/creditKarmaPromo';
import { usePriceDrop } from '~/hooks/vdp';
import useIsPriceLoading from '~/hooks/vdp/selectors/useIsPriceLoading';
import { Wrapper } from './Price.styles';
import PriceDrop from './PriceDrop';
import PriceWithCreditKarmaPromo from './PriceWithCreditKarmaPromo';
import PriceWithDiscount from './PriceWithDiscount';

function Skeleton({ width }: { width: number }) {
  return (
    <div className="h-24 py-4 m:h-32" style={{ width }}>
      <div className="h-full bg-grey-1" />
    </div>
  );
}

export default function Price() {
  const { previousPrice = 0, price = 0 } = useGetVehicleDetails();
  const isLoading = useIsPriceLoading(DiscountContext, TradeContext);
  const { showPriceDrop } = usePriceDrop();
  const { creditKarmaPromoAmount, shouldShowCkPromo } =
    useGetCkPromoFromDiscountContext();

  const PriceToShow = () => {
    switch (true) {
      case shouldShowCkPromo:
        return (
          <PriceWithCreditKarmaPromo
            price={price}
            creditKarmaPromoAmount={creditKarmaPromoAmount}
          />
        );
      case showPriceDrop:
        return <PriceDrop previousPrice={previousPrice} price={price} />;
      default:
        return <PriceWithDiscount price={price} />;
    }
  };

  return (
    <Wrapper>{isLoading ? <Skeleton width={175} /> : <PriceToShow />}</Wrapper>
  );
}
